const initialState = {
  gatewayList: [],
  terminalList: [],
  psp: [],
  mainCategories: [],
  bankAccounts: [],
  error: false,
  loading: false,
  newAccountModal: false,
  gatewayInfo: {},
};

export default initialState;
